import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './LoginRequired.scss';

interface LoginRequiredProps {
  children: React.ReactNode;
  title?: string;
}

// Страница доступна только вошедшим: гость видит пояснение и кнопки входа/регистрации вместо данных
const LoginRequired: React.FC<LoginRequiredProps> = ({
  children,
  title = 'Войдите, чтобы посмотреть детали турнира',
}) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user) return <>{children}</>;

  return (
    <div className="login-required" role="status">
      <h2 className="login-required__title">{title}</h2>
      <p className="login-required__text">
        Списки участников, турнирные сетки и результаты доступны только зарегистрированным пользователям.
      </p>
      <div className="login-required__actions">
        <Link to="/login" state={{ from: location }} className="login-required__btn login-required__btn--solid">Войти</Link>
        <Link to="/register" className="login-required__btn">Зарегистрироваться</Link>
      </div>
    </div>
  );
};

export default LoginRequired;
